import { Box, Button, Divider } from '@material-ui/core';
import {
  FetchWsCatalogueProductTypes,
  fetchWsCatalogueProducts,
} from '@src/reducers/wsCatalogue';
import { TimelineEvent } from '@src/types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

interface IChatMessageWsCatalogueProductWrapper {
  message: Partial<TimelineEvent>;
}

export type IChatMessageWsCatalogueProduct =
  IChatMessageWsCatalogueProductWrapper & {
    labels: { [key: string]: string };
    text?: string;
    handleClickDetail: (id: string, catalogId: string) => void;
  };

const ChatMessageWsCatalogueProductWrapper: React.FC<
  IChatMessageWsCatalogueProductWrapper
> = ({ message }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const labels = {
    button: formatMessage({ id: 'Ws.Catalogue.product.see.button' }),
    productTitle: formatMessage({ id: 'Ws.Catalogue.product.message.title' }),
  };

  return (
    <ChatMessageWsCatalogueProduct
      message={message}
      labels={labels}
      text={message?.text}
      handleClickDetail={(id, catalogId) =>
        dispatch(
          fetchWsCatalogueProducts({
            retailerIds: id,
            catalogId,
            type: FetchWsCatalogueProductTypes.PRODUCT,
          })
        )
      }
    />
  );
};

const ChatMessageWsCatalogueProduct: React.FC<
  IChatMessageWsCatalogueProduct
> = ({ message, labels, text, handleClickDetail }) => {
  const { catalogueProduct } = message;
  if (!catalogueProduct) return null;
  const {
    id,
    name,
    image_url: imageUrl,
    price,
    catalog_id: catalogId,
  } = catalogueProduct;
  const { button, productTitle } = labels;

  return (
    <Box display="flex" flexDirection="column">
      <img
        src={imageUrl}
        alt={name}
        style={{
          objectFit: 'contain',
          width: '100%',
          height: '100%',
          maxWidth: '180px',
          maxHeight: '126px',
          borderRadius: '8px',
        }}
      />

      <Box color="#000" fontWeight={500} fontSize={12} mt="8px">
        {productTitle}
      </Box>
      <Box color="#000" fontWeight={500} mt="2px">
        {name}
      </Box>
      <Box color="rgba(0, 0, 0, 0.40)" fontSize={12}>
        {price}
      </Box>
      {text && (
        <>
          <Divider style={{ marginTop: '16px', marginBottom: '8px' }} />
          <Box>{text}</Box>
        </>
      )}
      <Box textAlign="left">
        <Button
          style={{
            padding: '2px 8px',
            height: '22px',
            fontSize: '12px',
            fontWeight: '600px',
            marginTop: '8px',
            borderRadius: '4px',
            justifyContent: 'center',
          }}
          color="primary"
          variant="contained"
          onClick={() => handleClickDetail(id, catalogId)}
        >
          {button}
        </Button>
      </Box>
    </Box>
  );
};

export default ChatMessageWsCatalogueProductWrapper;
